/* Reads Shopify permission decisions; never sets consent on the shopper's behalf. */
(() => {
  let allowed;
  function syncConsent() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || !window.WiredAffiliate) return;
    let next = false;
    try {
      next = privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (_) { next = false; }
    if (next === allowed) return;
    allowed = next;
    const operation = next ? window.WiredAffiliate.start() : window.WiredAffiliate.revoke();
    Promise.resolve(operation).catch(() => console.warn('Wired referral consent update unavailable.'));
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  if (window.Shopify?.customerPrivacy) {
    syncConsent();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => {
      if (!error) syncConsent();
    });
  }
  // If the privacy API cannot load, tracking remains disabled.
})();
